//VideoBookHome.jsx
import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import Tooltip from '../../components/utils/Tooltip';
import '../learning/styles/BookShelf.css';
import videobookimage from '../../assets/pageimages/VideoBook.webp';
import VideoBookList from './VideoBookList';


const VideoBookHome = () => {
    const tooltiptext = "About Think5Whys";

    return (
        <MainLayout>
            <div className="min-h-full py-8 bg-gradient-to-r from-blue-300 via-blue-500 to-blue-700 mt-8">
                <h2 className='text-2xl font-bold text-white text-center mb-6'>My Video Books</h2>
                <div className="min-h-[100vh] px-4">
                    <div className="flex justify-center mb-6">
                    <img src={videobookimage} style={{ width:' 300px', height: 'auto'}} className="rounded-lg shadow-lg w-full max-w-md" />
                    </div>
                    <div className="flex justify-center items-center">
                        <VideoBookList/>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default VideoBookHome;
